import React, { useMemo } from "react";

const STATUS_META = {
  over: { label: "Closed", cls: "exam-status--over" },
  ongoing: { label: "Ongoing", cls: "exam-status--ongoing" },
  upcoming: { label: "Upcoming", cls: "exam-status--upcoming" },
};

export default function SubMenu({
  examName,
  logoSrc,
  applyStatus,
  applyLink,
  officialLink,
  calendarDate,
}) {
  const { status, dateLabel } = useMemo(() => {
    let _status = String(applyStatus || "").toLowerCase();
    let _dateLabel = calendarDate;

    if (!calendarDate) {
      return { status: "over", dateLabel: "Closed" };
    }

    if (_status === "over" || String(calendarDate).toLowerCase() === "closed") {
      return { status: "over", dateLabel: "Closed" };
    }

    const parsedDate = new Date(calendarDate);

    if (!isNaN(parsedDate.getTime())) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const parsedDateOnly = new Date(parsedDate);
      parsedDateOnly.setHours(0, 0, 0, 0);

      if (today > parsedDateOnly) {
        return { status: "over", dateLabel: "Closed" };
      } else {
        const parts = parsedDateOnly.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
        }).split(" ");
        if (parts.length >= 2) {
          _dateLabel = `${parts[0]} ${parts[1]}`.toUpperCase();
        }
      }
    }

    return { status: _status, dateLabel: _dateLabel };
  }, [applyStatus, calendarDate]);

  const meta = STATUS_META[status] || STATUS_META.upcoming;

  return (
    <article className="exam-card">
      <div className="exam-card__logo">
        <img src={logoSrc || ""} alt={`${examName} logo`} loading="lazy" />
      </div>

      <div className="exam-card__body">
        <div className="exam-card__top">
          <h4 className="exam-card__name" title={examName}>
            {examName}
          </h4>
          <span className="exam-card__date">
            <i className="pi pi-calendar" />
            {dateLabel}
          </span>
        </div>

        <span className={`exam-status ${meta.cls}`}>
          <span className="exam-status__dot" />
          {meta.label}
        </span>

        <div className="exam-card__actions">
          {status === 'ongoing' && applyLink && applyLink !== '#' && (
            <a
              href={applyLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="exam-btn exam-btn--apply"
            >
              <i className="pi pi-send" /> Apply
            </a>
          )}
          <a
            href={officialLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className="exam-btn exam-btn--official"
            style={status !== 'ongoing' || !applyLink || applyLink === '#' ? { width: '100%', justifyContent: 'center' } : {}}
          >
            <i className="pi pi-external-link" /> {status !== 'ongoing' || !applyLink || applyLink === '#' ? "Visit Website" : "Website"}
          </a>
        </div>
      </div>
    </article>
  );
}
